import { CurrencyUnitEnum, EnergyUnitEnum, PowerUnitEnum, TemperatureUnitEnum } from '@simOn/common/units';
import { PROJECT_INITIAL_VIEW } from './users.interface';

export const DEFAULT_USER_PREFERENCES = {
  showUnauthorizedUserModal: false,
  projectInitialView: PROJECT_INITIAL_VIEW.ThreeDView,
  autoReportErrors: false,
  showPowerAsPrice: false,
  priceForOneEnergyUnit: 0,
  priceCurrency: '$',
  openAttachmentInNewTab: false,
  units: {
    temperature: TemperatureUnitEnum.Celsius,
    energy: EnergyUnitEnum.kWh,
    power: PowerUnitEnum.Watt,
    currency: CurrencyUnitEnum.Currency
  }
} as const;
